import axios from './axios';
import { Query, buildQuery } from '../utils/query';

// eslint-disable-next-line import/prefer-default-export
export const loadCatalog = <T>(queryObject?: Query) => {
  const query = buildQuery(queryObject);

  return axios.get<T>(`/catalog${query}`);
};
